import {
  SET_ACCESS_TOKEN,
  EMPTY_TOKENS,
  RECIEVE_ITEM,
  REQUEST_ITEM,
  ERROR_ON_FETCH,
  CLEAR_FETCHED_ITEM,
} from "../Actions/apiActions";

const initialState = {
  accessToken: "",
  fetching: false,
  fetched: false,
  fetchedItem: "",
  error: null,
};

export default function apiReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_ACCESS_TOKEN: {
      return {
        accessToken: payload,
      };
    }
    case EMPTY_TOKENS: {
      return {
        accessToken: payload,
      };
    }
    case REQUEST_ITEM: {
      return {
        ...state,
        fetching: true,
      };
    }
    case ERROR_ON_FETCH: {
      console.log("RECIEVED ERROR ITEM: ", payload);
      return {
        ...state,
        fetching: false,
        error: payload,
      };
    }
    case RECIEVE_ITEM: {
      console.log("RECIEVED ITEM: ", payload);
      let payloadObj = payload;
      if (payload.data) {
        payloadObj = payload.data;
        payloadObj["fetchedEAN"] = payload.fetchedEAN;
        payloadObj["succesfulFetch"] = payload.succesfulFetch;
      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        fetchedItem: payloadObj,
      };
    }
    case CLEAR_FETCHED_ITEM: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        fetchedItem: "",
      };
    }
    default:
      return state;
  }
}
